// components
import IconButton from "components/icon-button";
import { ReactComponent as OutlinePlus } from "assets/svg/outline-plus.svg";
import { ReactComponent as OutlineTrash1 } from "assets/svg/outline-trash-1.svg";
import { ReactComponent as OutlineEdit1 } from "assets/svg/outline-edit-1.svg";
// styles
import styles from "./ActionsBar.module.scss";
// utils
import getClasses from "utils/getClasses";

type Props = {
  onCreate?: (() => void) | undefined;
  onDelete?: (() => void) | undefined;
  onUpdate?: (() => void) | undefined;
  iconClass?: string;
  className?: string;
};
const ActionsBar = ({
  onCreate,
  onDelete,
  onUpdate,
  className,
  iconClass,
}: Props) => (
  <div className={getClasses(styles["actions-bar"], className)}>
    {onUpdate && (
      <IconButton
        className={getClasses(
          styles["actions-bar__icon"],
          styles["actions-bar__icon--primary"],
          iconClass,
        )}
        onClick={onUpdate}
      >
        <OutlineEdit1 />
      </IconButton>
    )}
    {onDelete && (
      <IconButton
        onClick={onDelete}
        className={getClasses(styles["actions-bar__icon"], iconClass)}
      >
        <OutlineTrash1 />
      </IconButton>
    )}

    {onCreate && (
      <IconButton
        className={getClasses(
          styles["actions-bar__icon"],
          styles["actions-bar__icon--primary"],
          iconClass,
        )}
        onClick={onCreate}
      >
        <OutlinePlus />
      </IconButton>
    )}
  </div>
);

export default ActionsBar;
